import React from "react";
import { Reveal } from "../lib/motion";
import { IMG } from "../data/site";

export const Lifestyle = () => {
  return (
    <section className="relative py-[clamp(64px,9vw,120px)]" data-testid="lifestyle-section">
      <div className="container-pm">
        <Reveal className="text-center mb-14">
          <p className="eyebrow mb-4">Aspiracja</p>
          <h2 className="font-display font-semibold text-white text-[clamp(34px,4.4vw,58px)] leading-[1.02] tracking-[-0.035em]">
            Twój styl życia. <span className="text-coral">Twoje zasady.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 container-pm">
        {IMG.lifestyle.map((item, i) => (
          <Reveal key={item.label} delay={i * 0.08} className="group">
            <div className="relative overflow-hidden rounded-xl aspect-[3/4] border border-white/10">
              <img
                src={item.src}
                alt={item.label}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
                width="400"
                height="533"
              />
              <div className="absolute inset-0 photo-overlay-v" />
              <span className="absolute bottom-4 left-4 font-display font-semibold text-white text-base md:text-lg">
                {item.label}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
